import { Link, useSearchParams } from "react-router-dom";
import { useFetch } from "../api";
import { Alerts, Badge, EmptyRow, Loading, Page, Pager, Tabs, UserLink } from "../components/ui";
import { money, PAGE_SIZE, qs, setQuery, text, when } from "../format";

export default function RoiFailures() {
  const [params, setParams] = useSearchParams();
  const page = Math.max(1, Number(params.get("page")) || 1);
  const status = params.get("status") || "";
  const list = useFetch("/roi-failures" + qs({ page, limit: PAGE_SIZE, status }));
  const rows = Array.isArray(list.data?.data) ? list.data.data : [];

  return (
    <Page
      title="ROI failures"
      text="Daily ROI credits that failed. A later successful retry marks the row resolved. The row stays so the history is still visible."
    >
      <Alerts error={list.error} />
      <Tabs
        value={status}
        onChange={(value) => setQuery(params, setParams, { status: value, page: "" })}
        options={[
          { value: "", label: "All" },
          { value: "failed", label: "Failed" },
          { value: "resolved", label: "Resolved" },
        ]}
      />
      {list.loading ? <Loading /> : (
        <div className="table-wrap">
          <table className="wide">
            <thead>
              <tr>
                <th>Member</th>
                <th>Package</th>
                <th>Purchase</th>
                <th>Day</th>
                <th>Credit date</th>
                <th className="num">Amount</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Resolved</th>
                <th>Saved</th>
              </tr>
            </thead>
            <tbody>
              {rows.length ? rows.map((row) => (
                <tr key={row.id}>
                  <td><UserLink user={row.user} /></td>
                  <td>{text(row.packageName)}</td>
                  <td>
                    {row.purchaseId ? (
                      <Link to={"/admin/purchases/" + row.purchaseId}>View</Link>
                    ) : "—"}
                  </td>
                  <td>{row.dayNumber}</td>
                  <td className="code">{text(row.creditDate)}</td>
                  <td className="num">{money(row.amount)}</td>
                  <td className="clamp">{text(row.reason)}</td>
                  <td><Badge value={row.resolved ? "resolved" : "failed"} /></td>
                  <td>{when(row.resolvedAt)}</td>
                  <td>{when(row.createdAt)}</td>
                </tr>
              )) : <EmptyRow cols={10} text={list.error ? "ROI failures could not be loaded" : "No ROI failures"} />}
            </tbody>
          </table>
        </div>
      )}
      {list.data ? (
        <Pager page={page} limit={PAGE_SIZE} total={list.data.total} onPage={(next) => setQuery(params, setParams, { page: next <= 1 ? "" : next })} />
      ) : null}
    </Page>
  );
}
